/**
 * [C33] Display helpers of the Store container: exact decimal sums and integer products over decimal strings
 * (BigInt, 6 places), for labels only — never a posted figure (ADR-02 §2.9, ADR-08 §2.1 item 2).
 */
import { decAdd, decSub, isZero, toScaled, fromScaled } from "../customers/format.js";

export { decAdd, decSub, isZero };

/** Whole units of a decimal string ("3", "3.0" → 3); 0 when absent. */
export function toInt(s: string | null | undefined): number {
  if (!s) return 0;
  const n = Number.parseInt(s, 10);
  return Number.isFinite(n) ? n : 0;
}

/** price × integer quantity, exact. */
export function decMulInt(price: string, qty: number): string {
  return fromScaled(toScaled(price) * BigInt(qty));
}
